$('#profile-block').on('shown.bs.dropdown', function () {
    $('#profile-block .score .count-number').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 1000,
            // easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/score-count.js